import Brand from "../api/Brand";
import { getEnvironment } from "./getEnvironment";

const environment = getEnvironment();
/**
 * Opens a preview of the brand in a new tab.
 * Ensures compatibility with iOS by opening a blank tab first.
 *
 * @param uuid - Unique identifier for the user
 * @param brand_id - Unique identifier for the brand
 */
export const previewRedirectHandler = (uuid?: string, brand_id?: string) => {
    if (!uuid || !brand_id) return;

    // Open an empty tab immediately (iOS treats this as user-initiated)
    const newTab = window.open("", "_blank");

    Brand.info(uuid, brand_id)
        .then((res) => {
            if (!res || !newTab) return;

            const url = new URL(environment.preview_address);
            const redirectUrl = `${url.protocol}//${res.address}.${
                url.hostname
            }${url.port ? `:${url.port}` : ""}`;
            //}${url.port ? `:${url.port}` : ""}/redirect/${uuid}`; // Temporarily removed redirect with uuid (fake login) since it doesn't work properly. It logs in under admin not creating a real user session.

            // Assign the new URL to the opened tab
            newTab.location.href = redirectUrl;
        })
        .catch((error) => {
            console.error("Error opening brand preview:", error);
            if (newTab) newTab.close(); // Close the tab if there's an error
        });
};
